import React from 'react';
import PrivateRoute from 'PrivateRoutes';
const REPORT = React.lazy(()=> import(/* webpackChunkName: "BreakReports" */'./components'));

const routes = () =>{ 
  console.log(`routes---- /reporting/call-report`)
  return (
  <PrivateRoute exact path="/reporting/call-report" component={REPORT} />
);
}

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/reporting/CallReport/routes.js